import Chip from '../../components/chip';
import Tooltip, { TooltipVariant } from '../../components/toolTip';

export const BenefitsBadgeVariant = {
  OnBenefits: 'onBenefits',
  UcdsNotCts: 'ucdsNotCts',
  NotOnBenefits: 'notOnBenefits',
} as const;

export type BenefitsBadgeVariantValue = typeof BenefitsBadgeVariant[keyof typeof BenefitsBadgeVariant];

const variantContent: Record<BenefitsBadgeVariantValue, { label: string, colour: string, definition: string }> = {
  [BenefitsBadgeVariant.OnBenefits]: {
    label: 'On Benefits',
    colour: 'pippink',
    definition: 'In receipt of Housing Benefit or Council Tax Reduction. '
      + 'This is the richest dataset with the most data fields available.',
  },
  [BenefitsBadgeVariant.UcdsNotCts]: {
    label: 'UCDS but not CTS',
    colour: 'pipgreen',
    definition: 'Matched to a Universal Credit reference but not claiming Council Tax Reduction. '
      + 'A reduced dataset — Income and Take Home Income fields are not available.',
  },
  [BenefitsBadgeVariant.NotOnBenefits]: {
    label: 'Not On Benefits',
    colour: 'pippurple',
    definition: 'Matched to a Council Tax liability but not in receipt of Housing Benefit or '
      + 'Council Tax Reduction. Minimal dataset.',
  },
};

export interface BenefitsBadgeProps {
  variant: BenefitsBadgeVariantValue,
}

// Pill naming the household's benefits classification, with an info tooltip that explains it
export default function BenefitsBadge({ variant }: Readonly<BenefitsBadgeProps>) {
  const { label, colour, definition } = variantContent[variant];

  return (
    <div className="inline-flex items-center gap-1">
      <Chip
        text={label}
        colour={colour}
        closeButton={false}
        small
        hasDot
        className="h-[26px] items-center max-w-none text-body-small"
      />
      <Tooltip label={`${label} definition`} text={definition} variant={TooltipVariant.Grey} />
    </div>
  );
}
